// lib/iconMap.ts

import {
  Home, Building2, Factory, Globe2, MapPin, Car, Map, TreeDeciduous, Compass, BarChart3,
  Trees, Navigation, Palette, Camera, QrCode, Users, Bell, MapIcon, Code2, FileText, CalendarX,
  MessageCircle, MessageSquare, BadgeIndianRupee, HelpCircle, Clock, Smartphone, Eye, MousePointerClick,
  Send, Layers, LayoutGrid, ListChecks, BadgeCheck, Mail, CircleHelp, NotebookPen, Check, X, Star, AlertTriangle,
  MapPinned,
  Images,
  Lightbulb,
  Route,
  Box,
  MonitorSmartphone,
  Presentation,
  LandPlot,
  Landmark,
  Hotel,
  CodeXml
} from "lucide-react";

export const iconMap = {
  Home,
  Building2,
  Factory,
  Globe2,
  MapPin,
  Car,
  Map,
  TreeDeciduous,
  Compass,
  BarChart3,
  Trees,
  Navigation,
  MessageCircle,
  Palette,
  Camera,
  QrCode,
  Users,
  Bell,
  CalendarX,
  MapIcon,
  Code2,
  FileText,
  MessageSquare,
  BadgeIndianRupee,
  HelpCircle,
  Clock,
  Smartphone,
  Eye,
  MousePointerClick,
  Send,
  Layers, 
  LayoutGrid, 
  ListChecks, 
  BadgeCheck, 
  Mail,
  CircleHelp,
  NotebookPen,
  Check,
  X,
  Star,
  AlertTriangle,
  Lightbulb,
  Route,
  Box,
  MapPinned,
  Images,
  MonitorSmartphone,
  Presentation,
  LandPlot,
  Landmark,
  Hotel,
  CodeXml
};